export default "__VITE_ASSET__Baz4ef$5__"